import React from "react";
import uuidv4 from "uuid/v4";

function IconTrendline() {
  const id = uuidv4();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
      <circle opacity=".1" cx="8" cy="8" r="8" fill="#9BA4B0" />
      <mask
        id={`icon-trendline-${id}`}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16">
        <circle cx="8" cy="8" r="8" fill="#9BA4B0" />
      </mask>
      <g mask={`url(#icon-trendline-${id})`}>
        <path stroke="#9BA4B0" strokeWidth="2" d="M1.293 14.021L14.021 1.293" />
      </g>
    </svg>
  );
}

export default IconTrendline;
